// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Model
import PayPlanAssignment from "@PayPlans/models/Assignments/Individual";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/payplans/Individual.svg";

export default function Individual() {
	return (
		<PageLayer
			title="Individual Pay Plan Assignments"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon
						viewBox="-2 -2 24 24"
						className="text-[var(--light-blue-color)] [&>path]:fill-[var(--light-blue-color)] !text-[28px]"
						component={Icon}
					/>
				</Stack>
			}
		>
			<PayPlanAssignment />
		</PageLayer>
	);
}
